import type { BatchIterationData } from './array-types/batch-iteration-data';

export const EMPTY_ARRAY = [];

export const EMPTY_BATCH_ITERATION_DATA = {
  currentBatchSize: 0,
  items: [],
} satisfies BatchIterationData<unknown>;